import React, { Fragment } from 'react'
import { Form, Icon } from 'util/ui'
import { Tip } from 'shared/components/ui/Typography'

export default function FormError({ error }) {
  return (
    <Fragment>
      <Form.Field>
        <Tip color="berry">
          <Icon name="times circle outline" />
          {error}
        </Tip>
      </Form.Field>
    </Fragment>
  )
}
